import {
  Construction,
  Droplets,
  Zap,
  Lightbulb,
  Phone as PhoneIcon,
  Building,
  Truck,
  Radar,
} from "lucide-react";

const Services = () => {
  const services = [
    {
      icon: Construction,
      title: "Travaux de Voirie",
      description:
        "Réalisation de suprastructures et aménagements extérieurs : pavé, béton désactivé, carrelage, bordures.",
      color: "bg-primary",
    },
    {
      icon: Droplets,
      title: "Assainissement",
      description:
        "Travaux d'assainissement complets pour projets résidentiels, commerciaux et industriels.",
      color: "bg-sky",
    },
    {
      icon: Building,
      title: "Adduction Eau Potable",
      description:
        "Installation et raccordement des réseaux d'alimentation en eau potable.",
      color: "bg-secondary",
    },
    {
      icon: Zap,
      title: "Électrification",
      description:
        "Travaux d'électrification BT-MT et construction de postes de transformation.",
      color: "bg-primary",
    },
    {
      icon: Lightbulb,
      title: "Éclairage Public",
      description:
        "Installation et maintenance des systèmes d'éclairage public urbain.",
      color: "bg-secondary",
    },
    {
      icon: PhoneIcon,
      title: "Réseau Téléphonique",
      description:
        "Pose et raccordement des infrastructures de télécommunication.",
      color: "bg-sky",
    },
    {
      icon: Truck,
      title: "Location de Matériel",
      description:
        "Mise à disposition d'engins de chantier pour vos projets de construction.",
      color: "bg-primary",
    },
    {
      icon: Radar,
      title: "Détection Réseaux",
      description:
        "Détection et cartographie des réseaux enterrés avant travaux.",
      color: "bg-secondary",
    },
  ];

  return (
    <section id="services" className="section-padding">
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-secondary font-semibold text-sm uppercase tracking-wider mb-4">
            Nos Domaines d'Activités
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Des Solutions Complètes pour vos
            <span className="text-primary"> Projets BTP</span>
          </h2>
          <p className="text-muted-foreground text-lg">
            GRAMAGEC contribue à la construction et au développement du Maroc de
            demain à travers une large gamme de compétences dans les travaux
            publics.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100">
              <div className="p-6">
                <div className="mb-4">
                  <div
                    className={`w-14 h-14 ${service.color} rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                    <service.icon className="w-7 h-7 text-white" />
                  </div>
                </div>
                <h3 className="font-heading font-bold text-lg text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  {service.description}
                </p>
                <div className="h-1 w-12 bg-yellow-400 rounded-full group-hover:w-full transition-all duration-500" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
